export default __webpack_public_path__ + "static/Appman_logo-dab3405e30e5f893cf63cae36ba4d4e2.png";